import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import api, { formatINR } from "@/lib/api";
import StatusBadge from "@/components/StatusBadge";
import { Plus } from "lucide-react";

export default function BorrowerDashboard() {
  const [apps, setApps] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  useEffect(() => {
    api.get("/applications").then(r => setApps(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="borrower-dashboard">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h1 className="text-2xl font-semibold text-slate-900">My Applications</h1>
          <p className="text-sm text-slate-600 mt-1">Track your loan applications and CarDr report status.</p>
        </div>
        <Button className="bg-teal-600 hover:bg-teal-700" data-testid="borrower-new-app-btn" onClick={() => navigate("/apply")}>
          <Plus size={16} className="mr-1" /> New Application
        </Button>
      </div>

      {loading ? (
        <div className="text-slate-500">Loading…</div>
      ) : apps.length === 0 ? (
        <Card className="p-8 border-slate-200 text-center">
          <div className="text-slate-700">You don't have any applications yet.</div>
          <Button className="mt-4 bg-teal-600 hover:bg-teal-700" onClick={() => navigate("/apply")} data-testid="empty-new-app-btn">Apply for a loan</Button>
        </Card>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {apps.map(a => (
            <Card key={a.id} className="p-5 border-slate-200 hover:border-teal-300 transition-colors" data-testid={`borrower-app-${a.application_id}`}>
              <div className="flex justify-between items-start">
                <div>
                  <div className="text-xs text-slate-500 font-mono">{a.application_id}</div>
                  <div className="font-semibold text-slate-900 mt-1">{a.vehicle?.make} {a.vehicle?.model}</div>
                  <div className="text-sm text-slate-600 mt-0.5">{a.vehicle?.year} · {a.vehicle?.fuel_type}</div>
                </div>
                <StatusBadge status={a.status} />
              </div>
              <div className="grid grid-cols-2 gap-3 mt-4 text-sm">
                <div>
                  <div className="text-xs text-slate-500">Loan amount</div>
                  <div className="font-mono text-slate-900">{formatINR(a.loan?.desired_loan_amount)}</div>
                </div>
                <div>
                  <div className="text-xs text-slate-500">EMI</div>
                  <div className="font-mono text-slate-900">{formatINR(a.loan_offer?.emi)}</div>
                </div>
              </div>
              <Link to={`/borrower/applications/${a.id}`} className="block mt-4 text-sm text-teal-700 font-medium" data-testid={`borrower-app-link-${a.application_id}`}>Open application →</Link>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
